<template></template>
<script>
import ErrorPage from '@/components/Error'
export default {
   props: ['pid'],
   mounted:function(){
        //var params = this.$route.params.pid;
        //var $wrap = $('.l-wrap');
        //var $projectLayer = $('.project-layer-wrap');
        var params = this.$route.params.pid;
        var $wrap = $('.l-wrap');
        var $projectLayerWrap = $('.project-layer-wrap');
        var $projectLayer = $('.project-layer');
        
    
        var webImg;//, mobileImg;

            webImg = params+'.png';
            //mobileImg = params+'-mobile.png';
        
        var _cWimg = document.createElement('img');
        try{
          _cWimg.src = require('../../static/img/project-detail/'+ webImg );
          $projectLayerWrap.fadeIn();
          $projectLayer.children('img').remove();
          $projectLayer.prepend(_cWimg); //.prepend(_cMimg)
          $('body').css('overflow','hidden');
        }catch(e){
          var cUrl = window.location.href;
          //this.$router.push(cUrl);
          
           if(cUrl.indexOf('uiux') >0){
                this.$router.push('/uiux');
           }else{
                this.$router.push('/main');
           }
        }
        
        //_cWimg.className = 'w-project-img';

       // var _cMimg = document.createElement('img');
       // _cMimg.src = require('../../static/img/project-detail/'+ mobileImg );
       // _cMimg.className = 'm-project-img';

        //console.log(webSrc, mobileSrc) 
        //$projectLayer.show().children('div').prepend(_cWimg).prepend(_cMimg);
       
       
   },
   created () {
    console.log('viewlayer')  
  }
}

</script>


// WEBPACK FOOTER //
// src/components/viewlayer.vue